import Component from '@glimmer/component';

interface TioStepOverviewSignature {
  Args: {
    steps: string[];
  };
  Element: HTMLDivElement;
}

export default class TioStepOverviewComponent extends Component<TioStepOverviewSignature> {
  add1(number: number) {
    return number + 1;
  }

  <template>
    <div ...attributes>
      <ol class="tio-col-flush sm:flex-row flex-wrap sm:items-stretch w-full list-none">
        {{#each @steps as |step index|}}
          {{#if (neq index 0)}}
            <li class="p-2 hidden sm:flex sm:float-left self-center">
              <svg
                width="33"
                height="14"
                viewBox="0 0 33 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  class="tio-step-overview__arrow"
                  d="M32.3334 7.00004L25.6667 0.333374V5.33337H0.666687V8.66671H25.6667V13.6667L32.3334 7.00004Z"
                ></path>
              </svg>
            </li>
          {{/if}}
          <li class="sm:float-left h-auto py-2 sm:p-2">
            <span
              class="tio-row-flush grid md:justify-items-center grid-cols-5 grid-rows-1 sm:grid-rows-2 sm:grid-cols-1 sm:w-40 h-full"
            >
              <div
                class="tio-row-center shrink-0 tio-bg-surface border-2 app-border-brand-strong app-status-text-brand rounded-full leading-10 h-9 w-9 md:h-12 md:w-12"
              >
                <p class="tio-text-xl-semibold">
                  {{this.add1 index}}
                </p>
              </div>
              <div class="col-span-4 md:justify-self-center sm:pt-2 md:text-center">
                {{step}}
              </div>
            </span>
          </li>
        {{/each}}
      </ol>
    </div>
  </template>
}
